import {AnimationBaseController, IAnimationControllerConfiguration, Inject} from "@denishussar/html5-game-engine";
import {GameLogic} from "../Logic/LockCellLogic";

export class CellController extends AnimationBaseController {
    $model: any;

    public constructor(
        @Inject private _options,
        @Inject private _gameLogic: GameLogic
    ) {
        super("CellController");
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        return {
            modelWatch: {
                state: (state) => {
                    this._updateState();
                },
            },
            onPointerDown: (e) => {
                if (this._gameLogic.closeCell(this.$model)) {
                    this._options.onComplete();
                }
            },
            onPointerUp: (e) => {
            },
        };
    }

    private _updateState(): void {
        this.gotoAndStop(this.$model.state);
    }

    protected onInitialize(): void {
        this._updateState();
    }

    protected onAnimationEvent(name: string, ...args): void {
    }
}
